module.exports = __webpack_public_path__ + "static/img/partner-kzyh.7799f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-kzyh.png
// module id = qGWE
// module chunks = 34